import { InFilterDefinition } from '@factorialco/f0-react'
import {
  PaymentRequestBeneficiaryFilterDocument,
  PaymentRequestBeneficiaryFilterQuery,
} from 'generated/resources/graphql'

import { useGraphqlDataSource } from 'modules/core/hooks/useGraphqlDataSource'
import i18n from 'modules/core/lib/i18n'

const extractConnection = (data: PaymentRequestBeneficiaryFilterQuery) =>
  data.banking.beneficiaryNameOptionsConnection

const extractNodes = (connection: ReturnType<typeof extractConnection>) =>
  connection.edges.map((edge) => edge.node)

type Node = ReturnType<typeof extractNodes>[number]

export const useBeneficiaryFilter = (): InFilterDefinition<string> => {
  const source = useGraphqlDataSource(
    {
      paginationType: 'infinite-scroll',
      fetchPolicy: 'cache-first',
      document: PaymentRequestBeneficiaryFilterDocument,
      perPage: 25,
      mapData: (data) => {
        const connection = extractConnection(data)
        return extractNodes(connection)
      },
      mapPagination: (data) => {
        const connection = extractConnection(data)
        const pageInfo = connection.pageInfo
        return {
          total: connection.totalCount ?? 0,
          cursor: pageInfo.endCursor ?? '0',
          hasNextPage: !!pageInfo.hasNextPage,
        }
      },
      mapVariables: ({ search }) => ({
        search,
      }),
    },
    []
  )

  return {
    label: i18n.t('banking.paymentRequests.filters.beneficiary'),
    type: 'in' as const,
    options: {
      source,
      mapOptions: (option: Node) => ({
        label: option.name,
        value: option.name,
      }),
    },
  }
}
